import Icon from '../components/Icon.vue'

Icon.register({
  'star-of-life': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M472 334.4c7.7 4.4 10.3 14.2 5.9 21.9l-32 55.4c-4.4 7.7-14.2 10.3-21.9 5.9l-135.9-78.4v156.9c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-156.8l-135.9 78.4c-7.7 4.4-17.5 1.8-21.9-5.9l-32-55.4c-4.4-7.7-1.8-17.4 5.9-21.9l135.9-78.4-135.9-78.4c-7.7-4.4-10.3-14.2-5.9-21.9l32-55.4c4.4-7.7 14.2-10.3 21.9-5.9l135.9 78.4v-156.9c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v156.8l135.9-78.4c7.7-4.4 17.5-1.8 21.9 5.9l32 55.4c4.4 7.7 1.8 17.4-5.9 21.9l-135.9 78.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-of-life.js
// module id = 1946
// module chunks = 0